export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/app/anime/[id]": [9,[2,3]],
		"/app/anime/[id]/thread/[threadId]": [10,[2,3,4]],
		"/app/chat": [11,[2]],
		"/app/client": [12,[2,5]],
		"/app/client/files": [13,[2,5]],
		"/app/client/library": [14,[2,5]],
		"/app/client/peers": [15,[2,5]],
		"/app/home": [16,[2]],
		"/app/player": [17,[2]],
		"/app/profile": [18,[2]],
		"/app/schedule": [19,[2]],
		"/app/search": [20,[2]],
		"/app/settings": [21,[2,6]],
		"/app/settings/accounts": [22,[2,6]],
		"/app/settings/app": [23,[2,6]],
		"/app/settings/changelog": [24,[2,6]],
		"/app/settings/client": [25,[2,6]],
		"/app/settings/extensions": [26,[2,6]],
		"/app/settings/interface": [27,[2,6]],
		"/app/w2g": [28,[2]],
		"/app/w2g/[id]": [29,[2]],
		"/authorize": [30],
		"/setup": [31,[7]],
		"/setup/extensions": [32,[7]],
		"/setup/network": [33,[7]],
		"/setup/storage": [34,[7]],
		"/update": [35]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';